


const adminRoutes: Record<string, string> = {
    Landing: '/',
    Booking: '/Booking',
    Impressum: '/Impressum',
    Datenschutz: '/Datenschutz',
    Blog: '/blog',
    AdminLogin: '/admin',
    AdminDashboard: '/admin/dashboard',
    AdminBookings: '/admin/bookings',
    AdminPlatforms: '/admin/maschinen',
    AdminCustomers: '/admin/kunden',
    AdminCalendar: '/admin/kalender',
    AdminSettings: '/admin/einstellungen',
    AdminInvoices: '/admin/rechnungen',
    AdminSiteContent: '/admin/inhalte',
};

export function createPageUrl(pageName: string) {
    return adminRoutes[pageName] || '/' + pageName.toLowerCase().replace(/ /g, '-');
}
